import React from 'react';
import PageTemplate from './PageTemplate';
export default function Career(props) { return <PageTemplate {...props} slug="Career" />; }